export enum FormTab {
	SIGN_IN = 'SIGN_IN',
	SIGN_UP = 'SIGN_UP',
};

export enum FormRoute {
	LOGIN = 'LOGIN',
	RECOVERY = 'RECOVERY',
	CHANGE_PASSWORD = 'CHANGE_PASSWORD',
	REGISTRATION = 'REGISTRATION',
};

export const tabsDataSource = [
	{
		value: FormTab.SIGN_IN,
		name: 'Вход',
	},
	{
		value: FormTab.SIGN_UP,
		name: 'Регистрация',
	},
];
